import {
  AddPaymentMethodProps,
  BulkImportProps,
  ConfirmDialogProps,
  ContactCreateProps,
  ContactDetailProps,
  DocumentCreateProps,
  DocumentPreviewProps,
  EntityVerificationProps,
  LinkEntityProps,
  PayFlowProps,
  PdfViewProps,
  ServiceDetailProps,
  SettingsProps,
  TaskCreateProps,
  TaskSignersProps,
  TaskReviewProps,
  AddClientOwnerProps,
  useModal,
} from './ModalContext';
import TaskCreateModal from '../../../components/TaskCreateModal';
import { SignModal, SignModalProps } from '../../modals/SignFlow/SignModal';
import { PayFlowModal } from '../../modals/PayFlow/PayModal';
import PdfViewModal from '../../../components/PdfViewModal/PdfViewModal';
import { SearchMobileModal } from '../../modals/SearchMobile/SearchMobile';
import ConfirmationDlg from '../../../components/ConfirmationDlg/ConfirmationDlg';
import { TaskSignersModal } from '../../../pages/TaskDetail/TaskSignersModal';
import { SettingsModal } from '../../modals/Settings/SettingModal';
import { EntityCreateModal } from '../../../pages/EntityCreateModal/EntityCreateModal';
import { ClientCreateModal } from '../../modals/ClientCreate/ClientCreate';
import AddPaymentMethodModal from '../../../components/AddPaymentMethodModal/AddPaymentMethodModal';
import { ContactCreateModal } from '../../../pages/ContactCreateModal/ContactCreateModal';
import { ContactDetailUpdateModal } from '../../../pages/ContactCreateModal/ContactDetailUpdateModal';
import VerificationDlg from '../../../pages/VerificationDlg/VerificationDlg';
import { BulkImport } from '../../../pages/BulkImport/BulkImport';
import CreateServiceModal from '../../../pages/ServiceCreateModal';
import { LinkEntityModal } from '../ClientDetailTabs/ClientProfileTab/components/LinkEntityModal/LinkEntityModal';
import DocumentCreateModal from '../../modals/DocumentCreate/DocumentCreateModal';
import { DocumentPreviewModal } from '../../modals/components/DocumentPreviewModal';
import { TaskReviewModal } from '../../modals/TaskReview';
import { AddClientOwnerModal } from '../../modals/AddClientOwner/AddClientOwnerModal';
export function ModalManager() {
  const { modals, closeModal } = useModal();

  return (
    <>
      {modals.map((modal) => {
        switch (modal.type) {
          case 'clientCreate':
            return (
              <ClientCreateModal
                key={modal.id}
                open={modal.isOpen}
                onClose={() => closeModal(modal.id)}
              />
            );
          case 'entityCreate':
            return (
              <EntityCreateModal
                key={modal.id}
                open={modal.isOpen}
                handleCloseModal={() => closeModal(modal.id)}
              />
            );
          case 'taskSigners':
            return (
              <TaskSignersModal
                key={modal.id}
                open={modal.isOpen}
                onClose={() => closeModal(modal.id)}
                {...(modal.props as TaskSignersProps)}
              />
            );
          case 'confirmDialog':
            return (
              <ConfirmationDlg
                key={modal.id}
                open={modal.isOpen}
                onClose={() => closeModal(modal.id)}
                {...(modal.props as ConfirmDialogProps)}
              />
            );
          case 'taskCreation':
            return (
              <TaskCreateModal
                key={modal.id}
                open={modal.isOpen}
                onClose={() => closeModal(modal.id)}
                {...(modal.props as TaskCreateProps)}
              />
            );
          case 'signFlow':
            return (
              <SignModal
                key={modal.id}
                //@ts-ignore
                open={modal.isOpen}
                //@ts-ignore
                onClose={() => closeModal(modal.id)}
                {...(modal.props as SignModalProps)}
              />
            );
          case 'payFlow':
            return (
              <PayFlowModal
                key={modal.id}
                open={modal.isOpen}
                onClose={() => closeModal(modal.id)}
                {...(modal.props as PayFlowProps)}
              />
            );
          case 'viewDocument':
            return (
              <PdfViewModal
                key={modal.id}
                open={modal.isOpen}
                onClose={() => closeModal(modal.id)}
                {...(modal.props as PdfViewProps)}
              />
            );
          case 'searchMobile':
            return (
              <SearchMobileModal
                key={modal.id}
                open={modal.isOpen}
                onClose={() => closeModal(modal.id)}
              />
            );
          case 'settings':
            return (
              <SettingsModal
                key={modal.id}
                open={modal.isOpen}
                onClose={() => closeModal(modal.id)}
                {...(modal.props as SettingsProps)}
              />
            );
          case 'entityVerification':
            return (
              <VerificationDlg
                key={modal.id}
                open={modal.isOpen}
                onClose={() => closeModal(modal.id)}
                {...(modal.props as EntityVerificationProps)}
              />
            );
          case 'addPaymentMethod':
            return (
              <AddPaymentMethodModal
                key={modal.id}
                open={modal.isOpen}
                handleClose={() => closeModal(modal.id)}
                {...(modal.props as AddPaymentMethodProps)}
              />
            );
          case 'contactCreate':
            return (
              <ContactCreateModal
                key={modal.id}
                open={modal.isOpen}
                handleCloseModal={() => closeModal(modal.id)}
                {...(modal.props as ContactCreateProps)}
              />
            );
          case 'contactDetail':
            return (
              <ContactDetailUpdateModal
                key={modal.id}
                open={modal.isOpen}
                handleCloseModal={() => closeModal(modal.id)}
                {...(modal.props as ContactDetailProps)}
              />
            );
          case 'bulkImport':
            return (
              <BulkImport
                key={modal.id}
                open={modal.isOpen}
                handleCloseModal={() => closeModal(modal.id)}
                {...(modal.props as BulkImportProps)}
              />
            );
          case 'serviceDetail':
            return (
              <CreateServiceModal
                key={modal.id}
                open={modal.isOpen}
                onClose={() => closeModal(modal.id)}
                service={(modal.props as ServiceDetailProps)?.service}
              />
            );
          case 'linkEntity':
            return (
              <LinkEntityModal
                key={modal.id}
                open={modal.isOpen}
                onClose={() => closeModal(modal.id)}
                {...(modal.props as LinkEntityProps)}
              />
            );
          case 'documentCreate':
            return (
              <DocumentCreateModal
                key={modal.id}
                open={modal.isOpen}
                onClose={() => closeModal(modal.id)}
                {...(modal.props as DocumentCreateProps)}
              />
            );
          case 'documentPreview':
            return (
              <DocumentPreviewModal
                key={modal.id}
                open={modal.isOpen}
                onClose={() => closeModal(modal.id)}
                {...(modal.props as DocumentPreviewProps)}
              />
            );
          case 'taskReview':
            return (
              <TaskReviewModal
                key={modal.id}
                open={modal.isOpen}
                onClose={() => closeModal(modal.id)}
                {...(modal.props as TaskReviewProps)}
              />
            );
          case 'addClientOwner':
            return (
              <AddClientOwnerModal
                key={modal.id}
                open={modal.isOpen}
                onClose={() => closeModal(modal.id)}
                {...(modal.props as AddClientOwnerProps)}
              />
            );

          default:
            return null;
        }
      })}
    </>
  );
}
